import React, { useState } from "react";
import { motion } from "framer-motion";
import { useWindowScroll } from "@mantine/hooks";

const CaretLeftIcon = () => {
  // Helper function to generate a unique ID if none is provided
  const uniqueId = `caret-left-icon-${Math.random().toString(36).substring(2, 10)}`;
  const uniqueIdPath = `caret-left-icon-path-${Math.random().toString(36).substring(2, 10)}`;

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 1024 1024"
      id={uniqueId}
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" id={uniqueIdPath} />
    </svg>
  );
};

const CaretRightIcon = () => {
  // Helper function to generate a unique ID for the SVG and path elements
  const uniqueId = `caret-right-icon-${Math.random().toString(36).substring(2, 10)}`;
  const uniquePathId = `caret-right-icon-path-${Math.random().toString(36).substring(2, 10)}`;

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 1024 1024"
      id={uniqueId}
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id={uniquePathId}
        d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
      />
    </svg>
  );
};

interface SidePanelProps {
  isParentBAA?: boolean;
  pageType?:string
}

const SidePanel = ({ isParentBAA = false, pageType = "" }: SidePanelProps) => {
  const buttonColor = "orange-500";
  const buttonTextColor = "white";

  const [scroll, scrollTo] = useWindowScroll(); // hook for scroll position
  const [viewPlan, setViewPlan] = useState(false);

  const handleToggle = () => {
    setViewPlan(!viewPlan);
  };
  const pageTypes = ["Product" , "Category" , "Articles"]
  const minScrollLenght = pageTypes.includes(pageType) ? 1100 : 150
  return (
    <>
      {scroll.y > minScrollLenght && (
        <div
          id="side-panel"
          className="fixed flex right-0 top-1/2 -translate-y-1/2 transition-all duration-300 overflow-hidden rounded-tl-xl rounded-bl-xl z-20 sidePanelAb"
          onClick={() => setViewPlan(!viewPlan)}
        >
          <div
            id="homepage-side-panel-button"
            className={`bg-${buttonColor} px-1 py-4 cursor-pointer flex justify-center items-center text-${buttonTextColor}`}
          >
            {viewPlan ? (
              <CaretRightIcon />
            ) : (
              <CaretLeftIcon />
            )}
          </div>
          <motion.div
            id="side-panel-content"
            animate={
              viewPlan
                ? { width: "auto", padding: "0.8rem" }
                : { width: 0, padding: 0 }
            }
            className="flex items-center bg-[#01AFEF] sidePanelAbTxtWrap"
          >
            <div id="side-panel-text">
              <p className="text-white md:text-xl uppercase whitespace-nowrap text-xs sidePanelAbTxt1">
                {isParentBAA ? "Register for Become an" : "Find Plans that fit"}
              </p>
              <p className="uppercase whitespace-nowrap md:text-2xl text-base sidePanelAbTxt2">
                {isParentBAA ? "Agent" : "your needs"}
              </p>
            </div>
            <button
              id="view-plans-button"
              className={`uppercase shadow-[0_5px_6px_-3px_gray] sidePanelAbBtn bg-${buttonColor} text-${buttonTextColor} mx-4 py-2 px-4 rounded-lg whitespace-nowrap text-base`}
              onClick={() => {
                scrollTo({ y: 0 });
                handleToggle();
              }}
            >
              {isParentBAA ? "Click Here" : "View Plans"}
            </button>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default SidePanel;